export default function TermsContent() {
  return (
    <div className="prose prose-indigo max-w-none">
      <p className="text-gray-600 mb-6">
        <strong>Effective Date:</strong> November 2025<br />
        <strong>Last Updated:</strong> November 2025
      </p>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">1. Acceptance of Terms</h3>
        <p className="text-gray-700">
          By accessing and using the CTE Course Platform ("Platform"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use the Platform.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">2. Description of Service</h3>
        <p className="text-gray-700">
          CTE Course Platform provides online educational content, including but not limited to course modules, labs, capstone projects, and case studies focused on AI prompting and agent systems. The Platform is owned and operated by CTE Consultants & General Sales LLC.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">3. User Accounts</h3>
        <p className="text-gray-700 mb-3">
          To access certain features of the Platform, you must create an account. You agree to:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Provide accurate, current, and complete information during registration</li>
          <li>Maintain and promptly update your account information</li>
          <li>Maintain the security of your password and account</li>
          <li>Accept responsibility for all activities under your account</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
        </ul>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">4. License and Access</h3>
        <p className="text-gray-700">
          Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, and revocable license to access and use the Platform for your personal, non-commercial educational purposes.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">5. User Conduct</h3>
        <p className="text-gray-700 mb-3">You agree not to:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Use the Platform for any illegal purpose or in violation of any laws</li>
          <li>Share your account credentials with others</li>
          <li>Reproduce, distribute, or create derivative works from Platform content without permission</li>
          <li>Attempt to gain unauthorized access to the Platform or related systems</li>
          <li>Interfere with or disrupt the Platform's operation</li>
          <li>Upload malicious code or engage in any harmful activities</li>
        </ul>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">6. Intellectual Property</h3>
        <p className="text-gray-700">
          All content on the Platform, including but not limited to text, graphics, logos, images, course materials, and software, is the property of CTE Consultants & General Sales LLC and is protected by intellectual property laws. You may not use, copy, or distribute any content without our express written permission.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">7. Submissions and User Content</h3>
        <p className="text-gray-700">
          By submitting content to the Platform (e.g., lab submissions, project work), you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, and display such content solely for the purpose of operating and improving the Platform.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">8. Disclaimers and Limitation of Liability</h3>
        <p className="text-gray-700 mb-3">
          THE PLATFORM IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. TO THE FULLEST EXTENT PERMITTED BY LAW, CTE CONSULTANTS & GENERAL SALES LLC DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p className="text-gray-700">
          We shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the Platform.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">9. Modifications to Service and Terms</h3>
        <p className="text-gray-700">
          We reserve the right to modify or discontinue the Platform at any time without notice. We may also update these Terms of Service periodically. Your continued use of the Platform after changes constitutes acceptance of the updated terms.
        </p>
      </section>

      <section className="mb-8">
        <h3 className="text-xl font-semibold text-gray-900 mb-3">10. Contact Information</h3>
        <p className="text-gray-700">
          For questions about these Terms of Service, please contact:<br />
          <strong>CTE Consultants & General Sales LLC</strong><br />
          Website: <a href="https://www.cteconsultants.net" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-700">www.cteconsultants.net</a>
        </p>
      </section>
    </div>
  );
}
